import { Injectable, Injector } from '@angular/core';
import { Namespace } from 'enums-lib';
import { Observable } from 'rxjs';
import { BullhornFileTypeProviderService } from './bullhorn.file-type-provider.service';

export interface IFileTypeProvider {
  getFileTypes(token: string, entityType: string): Observable<{ id: string; label: string }[]>;
}

@Injectable({ providedIn: 'root' })
export class FileTypeProviderService {
  constructor(private injector: Injector) {}

  getFileTypeProvider(namespace: Namespace | string): IFileTypeProvider {
    if (namespace === Namespace.bullhorn) {
      return this.injector.get(BullhornFileTypeProviderService);
    }

    throw new Error(`No file type provider for '${namespace}'.`);
  }
}
